module.exports = "images/bg-header.jpg";